import { useState } from 'react'
import axios from "axios"
import { Link, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { useAuth } from '../../contexts/AuthContext'
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  ArrowRight,
  AlertCircle,
  Check
} from 'lucide-react'
import toast from 'react-hot-toast'

const LoginPage = () => {
  const { login, isAuthenticated } = useAuth()
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  console.log(formData)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (isAuthenticated) {
    return <Navigate to='/app/dashboard/DashboardOverview' replace />
    console.log(formData)
    console.log(isAuthenticated)
    console.log(login)
    console.log(useAuth)
    console.log(showPassword)
    console.log(errors)
    console.log(isSubmitting)
    console.log(setFormData)
    console.log(setErrors)
    console.log(setIsSubmitting)
    console.log(setShowPassword)
    console.log(setIsAuthenticated)
    console.log(setIsSubmitting)
    console.log(setIsSubmitting)
  }

  // Validate form
  const validateForm = () => {
    const newErrors = {}

    const emailTrimmed = formData.email.trim()
    const passwordTrimmed = formData.password.trim()

    if (!emailTrimmed) {
      newErrors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(emailTrimmed)) {
      newErrors.email = 'Email is invalid'
    }

    if (!passwordTrimmed) {
      newErrors.password = 'Password is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault()

    console.log("FormData before validation:", formData)

    if (!validateForm()) return

    setIsSubmitting(true)
    try {
      // Use the login function from AuthContext instead of direct axios call
      const result = await login({
        email: formData.email.trim(),
        password: formData.password
      })

      if (result.success) {
        toast.success('Login successful!')
        console.log('Login successful, redirecting to dashboard...')
        // Force navigation after successful login
        window.location.href = '/app/dashboard/'
      }
    } catch (error) {
      console.error('Login error:', error.response?.data || error)
      const message =
        error.response?.data?.message || 'Invalid email or password'
      setErrors({ general: message })
      toast.error(message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>Login to FiindIt 🔐 - Access Your Digital Profile</title>
        <meta name="description" content="Login to your FiindIt account and manage your smart digital profile. Connect instantly, share effortlessly." />
      </Helmet>

      <div className="min-h-screen bg-white dark:bg-black flex items-center justify-center px-4 py-8 transition-colors duration-300">
        <div className="max-w-md w-full">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <Link to="/" className="inline-flex items-center space-x-2 mb-6">
             
              <span className="text-2xl font-bold text-gray-900 dark:text-orange-500">FiindIt</span>
            </Link>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              🔐 Welcome Back
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Sign in to access your digital profile and dashboard
            </p>
          </motion.div>

          {/* Login Form */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white dark:bg-gray-900 p-8 rounded-3xl shadow-xl border border-gray-100 dark:border-black"
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              {errors.general && (
                <p className="text-red-500 text-sm text-center mb-2">{errors.general}</p>
              )}

              {/* Email Field */}
              <div className="relative">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all ${errors.email
                        ? 'border-red-500 bg-red-50 dark:bg-red-900/20'
                        : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800'
                      }`}
                    placeholder="Enter your email address"
                  />
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  {formData.email && !errors.email && /\S+@\S+\.\S+/.test(formData.email) && (
                    <Check className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-green-500" />
                  )}
                </div>
                {errors.email && (
                  <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-red-500 text-sm mt-1 flex items-center space-x-1"
                  >
                    <AlertCircle className="w-4 h-4" />
                    <span>{errors.email}</span>
                  </motion.p>
                )}
              </div>

              {/* Password Field */}
              <div className="relative">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={`w-full pl-10 pr-12 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all ${errors.password
                        ? 'border-red-500 bg-red-50 dark:bg-red-900/20'
                        : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800'
                      }`}
                    placeholder="Enter your password"
                  />
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
                {errors.password && (
                  <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-red-500 text-sm mt-1 flex items-center space-x-1"
                  >
                    <AlertCircle className="w-4 h-4" />
                    <span>{errors.password}</span>
                  </motion.p>
                )}
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex items-center justify-between">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="w-4 h-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500"
                  />
                  <span className="ml-2 text-sm text-gray-600 dark:text-gray-400">
                    Remember me
                  </span>
                </label>
                <Link
                  to="/app/forgot-password"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <motion.button
                type="submit"
                disabled={isSubmitting}
                whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
                whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
                className="w-full bg-blue-500 text-white py-3 px-6 rounded-lg font-medium hover:from-primary-600 hover:to-accent-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Signing in...</span>
                  </>
                ) : (
                  <>
                    <span>Sign In</span>
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </motion.button>
            </form>
            {/* Register Link */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-center mt-6 pt-6 border-t border-gray-200 dark:border-gray-700"
            >
              <p className="text-gray-600 dark:text-gray-400">
                Don't have an account?{' '}
                <Link
                  to="/app/register"
                  className="text-primary-500 hover:text-primary-600 font-medium transition-colors"
                >
                  Create one now 🚀
                </Link>
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default LoginPage
